import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';
import { TEST_WALLET_STATUS } from '../../../../../constants/status';
// import { DeliveryStatus } from '../../../../../constants/status';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getWalletTransactions(filters) {
  const mappedFilters = { ...filters };

  if (filters.status) {
    mappedFilters.status = TEST_WALLET_STATUS[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(
      `${endpoint}/wallet-transactions-listing?${query}`,
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getWalletGroups(filters) {
  //   const { groupId, ...otherFilters } = filters;

  const mappedFilters = { ...filters };

  if (filters.status) {
    mappedFilters.status = TEST_WALLET_STATUS[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(
      `${endpoint}/group/wallet-transactions?${query}`,
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}
async function transactionAction(payload) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    // Pass payload as the second argument
    const { data: response } = await axios.post(
      `${endpoint}/auction-payment/action`,
      payload,
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

export {
  getWalletTransactions,
  transactionAction,
  getWalletGroups,
  //  getDeliveryGroups, auctionApprove, auctionReject, clientFundSettle
};
